
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "building",
      key: "id",
      url: {
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
          rules: [{ required: false, trigger: "blur" }],
          onAddress: this.addres,
          onCancel: this.cancel,
        },
        {
          label: "楼宇名称",
          name: "buildingName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "最高楼层",
          name: "maxFloor",
          value: 1,
          min:1,
          type: "number",
          rules: [{ required: true, trigger: "blur",type:"number"}],
        },
        {
          label: "楼层名称",
          name: "floorName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur"}],
        },

      ],
      forms: {
        buildingId:""
      },
    };
  },
  created() {
    let query = this.$route.query;
    if (query.action === "edit") {
      this.items[this.getItemIndex("maxFloor")].type = "kong";
      this.forms.buildingId = query.buildingId
    }
    if (query.action === "add") {
      this.items[this.getItemIndex("floorName")].type = "kong";
    }

  },
  mounted() {
  },
  methods: {

    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/floor/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
              .load(
                  `/admin/system/floor/add`,
                  q,
                  "POST"
              )
              .then((res) => {
                this.sloading = false;
                if (res.status) {
                  $utils.toast.success("保存成功");
                  $utils.url.go(-1);
                }
              })
              .catch((e) => {
                this.sloading = false;
                $utils.toast.error("保存异常" + e.message);
              });
        }
      });
    },

  },
};
</script>
